import React from "react";
import MUIRating from "@mui/material/Rating";
import FilledStar from "assets/images/svg/rate_larg.svg";
import EmptyStar from "assets/images/svg/rate_empty_larg.svg";

enum Sizes {
  small = 18,
  medium = 24,
  large = 48,
}

function Rating({
  rating,
  onChange,
  size = "medium",
  readOnly = false,
}: {
  rating: number;
  readOnly?: boolean;
  onChange?: (r: number) => void;
  size?: "small" | "medium" | "large";
}) {
  const width = Sizes[size];
  return (
    <MUIRating
      readOnly={readOnly}
      precision={0.5}
      icon={<img alt="filled-star" width={width} src={FilledStar} />}
      emptyIcon={<img alt="empty-star" src={EmptyStar} width={width} />}
      value={rating}
      onChange={(e) => onChange?.(+(e.target as HTMLInputElement).value)}
    />
  );
}

export default Rating;
